import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div id="about_us">
      <h1 className="title">Escola de Kickboxing Hugo Matos</h1>
      <div className="paragrafo">
        <p>
          Somos um centro de treino dedicado à formação de atletas e praticantes da modalidade, promovendo a disciplina, o respeito e a evolução contínua.
        </p>
        <p>
          Sob a liderança do Mestre Hugo Matos, 3.º Dan, a escola já formou inúmeros campeões e marcou a vida de centenas de alunos, incentivando não só o alto rendimento desportivo, mas também o desenvolvimento pessoal.
        </p>
        <p>
          Com uma metodologia estruturada e um ambiente motivador, a escola destaca-se pelo compromisso com a excelência técnica e pela valorização dos princípios fundamentais das artes marciais.
        </p>
      </div>

      <section className="section-aboutUs" aria-label="Missão, visão e valores">
        <article className="about-us">
          <h2>Missão</h2>
          <p>
            Oferecer um ambiente acolhedor e inclusivo para a prática de kickboxing, formando não apenas atletas, mas também cidadãos íntegros e respeitadores.
          </p>
          <p>
            Com foco no desenvolvimento físico e psicológico, a escola proporciona tanto alta competição como bem-estar aos seus alunos.
          </p>
        </article>

        <article className="about-us">
          <h2>Visão</h2>
          <p>
            Ser reconhecida como uma referência no ensino do kickboxing, promovendo uma verdadeira família unida por valores como o civismo, o respeito e a humildade, e formando campeões dentro e fora dos tatamis.
          </p>
        </article>

        <article className="about-us">
          <h2>Valores</h2>
          <ul className="list">
            <li>Civismo</li>
            <li>Respeito</li>
            <li>Humildade</li>
            <li>Espírito de comunidade</li>
            <li>Bem-estar físico e psicológico</li>
            <li>Compromisso com a formação de indivíduos idóneos e amistosos</li>
          </ul>
        </article>
      </section>
    </div>
  );
};

export default AboutUs;
